export default "__VITE_ASSET__DlMYLOLt__"